import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import './TS_ReadMore.scss';
import { _className } from '../../utils/tools.js';
export class TS_ReadMore extends ComponentSync {
    ref = React.createRef();
    textRef = React.createRef();
    static defaultProps = {
        readMoreText: (showingMore) => showingMore ? 'Read Less' : 'Read More',
    };
    deriveStateFromProps(nextProps, state) {
        state.text = nextProps.text;
        state.showMore ??= false;
        return state;
    }
    componentDidMount() {
        new ResizeObserver(() => this.setState({ width: this.ref.current?.scrollWidth })).observe(this.ref.current);
        this.forceUpdate();
    }
    getCollapsedText = () => {
        if (this.state.showMore)
            return this.state.text;
        const container = this.ref.current;
        const textContainer = this.textRef.current;
        if (!container || !textContainer)
            return this.state.text;
        const computedStyle = getComputedStyle(container);
        const width = container.clientWidth - parseFloat(computedStyle.paddingInline);
        const collapsedNumLines = this.props.collapsedHeight / parseInt(computedStyle.lineHeight);
        const charsPerLine = Math.floor(width / parseInt(computedStyle.fontSize));
        //Count text lines
        const textLines = this.state.text.split('\n').reduce((lines, curr, i) => {
            const innerLines = Math.ceil((curr.length) / charsPerLine);
            //Always push the first line
            if (i === 0) {
                lines.push({ text: curr, lines: innerLines });
                return lines;
            }
            //Don't push empty strings
            if (!curr.length)
                return lines;
            //Don't push if collapsed line threshold has passed
            if (lines.reduce((total, curr) => total + curr.lines, 0) >= collapsedNumLines)
                return lines;
            //Push the text
            lines.push({ text: curr, lines: innerLines });
            return lines;
        }, []);
        let text = '';
        const readMoreTextLength = (this.props.readMoreText(this.state.showMore).length) + 3;
        let remainingLines = collapsedNumLines;
        //Concat all lines with logic
        textLines.forEach((textLine, i) => {
            //If not last textLine, append to text with a new line char
            if (i !== textLines.length - 1) {
                text += textLine.text + '\n';
                remainingLines -= textLine.lines;
                return;
            }
            //Is last text line
            //Collect data
            const lastLineAllowedChars = charsPerLine * remainingLines * 1.75; // Actual chars allowed for this textLine  (1.75 factor to account for letters that are smaller than the font size + kerning)
            const lastLineTotalChars = textLine.text.length + readMoreTextLength + 15; // Total chars that will be in this line + the button chars + some margin for safety
            const overflowingChars = lastLineTotalChars - lastLineAllowedChars;
            //If there are overflowing chars, deduct from text
            if (overflowingChars > 0)
                text += textLine.text.substring(0, textLine.text.length - overflowingChars);
            else
                text += textLine.text;
        });
        return text;
    };
    renderButton = () => {
        return _jsxs(_Fragment, { children: [this.state.showMore ? ' ' : '... ', _jsx("span", { className: 'ts-read-more__button', onClick: () => this.setState({ showMore: !this.state.showMore }), children: this.props.readMoreText(this.state.showMore) })] });
    };
    renderText = () => {
        return _jsx("span", { className: 'ts-read-more__text', ref: this.textRef, children: this.getCollapsedText() });
    };
    render() {
        const style = {
            '--collapsed-height': `${this.props.collapsedHeight}px`,
        };
        return _jsxs("p", { className: _className('ts-read-more', this.state.showMore ? 'expand' : undefined), style: style, ref: this.ref, children: [this.renderText(), this.renderButton()] });
    }
}
//# sourceMappingURL=TS_ReadMore.js.map